import React from 'react';
import { AuscultationContext } from 'providers/AuscultationProvider';

export function useAuscultation() {
  return React.useContext(AuscultationContext);
}
